/**
 * @fileoverview DELETE handler for the "/companies/:company_id/mobile_app_linking_configs/:id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { deleteCompaniesCompanyIdMobileAppLinkingConfigsIdCacheKeys } from "./constants";
import type { DeleteCompaniesCompanyIdMobileAppLinkingConfigsIdProps } from "./types";

export const deleteCompaniesCompanyIdMobileAppLinkingConfigsId = reactQueryMutationAdapter(
  deleteCompaniesCompanyIdMobileAppLinkingConfigsIdCacheKeys,
  createMutationFetcherFunctionWithShadowError()(
    (props: DeleteCompaniesCompanyIdMobileAppLinkingConfigsIdProps): Promise<void> => {
      return fetch(
        `/companies/${props.companyId}/mobile_app_linking_configs/${props.id}`,
        "DELETE",
        {},
        undefined,
        { propagateFetchRequestError: false }
      );
    }
  )
);
